<template>
  <div>
    <label class="col-form-label font-weight-bold"> {{ text }} </label>

    <div>
      <input
        v-model="watHidra"
        type="checkbox"
        :disabled="disabled"
        :readonly="readonly"
      />
      <label class="col-form-label font-weight-bold"> Hidraulico </label>
    </div>
    <div>
      <input
        v-model="watPne"
        type="checkbox"
        :disabled="disabled"
        :readonly="readonly"
      />
      <label class="col-form-label font-weight-bold"> Pneumatico </label>
    </div>
    <div>
      <input
        v-model="watMec"
        type="checkbox"
        :disabled="disabled"
        :readonly="readonly"
      />
      <label class="col-form-label font-weight-bold"> Pneumatico </label>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valor: "",
      newvalor: "",
      watHidra: false,
      watMec : false,
      watPne : false,
      sisextra : { hidra : false,pne : false, mec : false }
      
    };
  },

  props: {
    text: String,
    tipo: String,
    placeholder: "",
    readonly: String,
    disabled: String,
    valor: String,

  },

  watch: {

    watHidra(val) {
      this.watHidra = val;
      this.sisextra.hidra = val;
      this.$emit("eventInputCheckbox", this.sisextra);
      
    },
     watPne(val) {
      this.watPne = val
      this.sisextra.pne = val;
      this.$emit("eventInputCheckbox", this.sisextra);

    },
     watMec(val) {
      this.sisextra.mec = val;
       this.$emit("eventInputCheckbox", this.sisextra);
    },

    
  },
};
</script>

<style scoped >
.flex {
  display: flex;
}
</style>